import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Translate } from '../../localization';

class Referral extends Component {
    userAddress;

    copyCodeToClipboard = () => {
        this.userAddress.select()
        document.execCommand("copy")
    }

    render() {
        const {userData:{referral_code, bonus_threshold, referral_reward_amount}} = this.props;
        //creating referral link for the user for the specific domain
        let { userData } = this.props;
        let refLink = (userData && userData.referral_code) ? "https://www.jackpotct.com/en-US/d/affiliate-invite?affiliate_code=" + userData.referral_code : '';

        return (
            <div className="ref-div" id="v-pills-authentication" role="tabpanel" aria-labelledby="v-pills-authentication-tab"> 
                <div className="referralUsername first-method">
                    {/* <h4 className='mb-4'> {Translate.refHeading} </h4>
                    <p>{Translate.refText1}</p>
                    <p>
                        {Translate.refText2}
                        {referral_reward_amount}
                        {Translate.refText3}
                        
                    </p> */}

                    <div className="copy-address">
                        <input readOnly="readonly" value= {refLink} ref={el => (this.userAddress = el)} />
                        <div className="copy-icon">
                            <img onClick={this.copyCodeToClipboard} className='pointer-cursor' src="/images/copy-icon.png" />
                        </div>
                    </div>
                    <div className="copy-btn">
                        <a id="add-factor" onClick={this.copyCodeToClipboard}>{Translate.refCopyText}</a>
                    </div>
                </div>
            </div> 
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userData: state.user.data,
        language: state.general.language,
    };
};

export default connect(mapStateToProps, null)(Referral);